import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { getRefreshToken } from '@/plugins/refreshClient'

let isRefreshing = false
let failedQueue = []

const isApiConnectionError = error => {
  return !error.response && (
    error.message === 'Network Error' ||
    error.code === 'ERR_NETWORK' ||
    error.code === 'ECONNABORTED'
  )
}

const redirectToMaintenance = async error => {
  error.__maintenanceRedirect = true

  if (router.currentRoute.name !== 'Manutencao') {
    await router.replace({
      name: 'Manutencao',
      query: {
        from: router.currentRoute.fullPath,
      },
    }).catch(() => {})
  }
}

const processQueue = (error, token = null) => {
  failedQueue.forEach(p => {
    error ? p.reject(error) : p.resolve(token)
  })
  failedQueue = []
}

axios.interceptors.response.use(
  response => response,
  async error => {
    console.log('axios', error)
    const originalRequest = error.config

    if (isApiConnectionError(error)) {
      await redirectToMaintenance(error)
      return Promise.reject(error)
    }

    if (!originalRequest || error.response?.status !== 401 || originalRequest._retry || originalRequest.skipAuthRefresh) {
      return Promise.reject(error)
    }

    originalRequest._retry = true

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject })
      }).then(token => {
        originalRequest.headers.Authorization = `Bearer ${token}`
        return axios(originalRequest)
      })
    }

    isRefreshing = true

    try {
      const res = await getRefreshToken()
      const { token } = res.data

      const currentUser = store.get('authStore@currentUser')
      store.commit('authStore/setUser', { ...res.data, companyId: currentUser?.companyId || res.data.companyId })
      axios.defaults.headers.common.Authorization = `Bearer ${token}`
      originalRequest.headers.Authorization = `Bearer ${token}`

      processQueue(null, token)
      return axios(originalRequest)
    } catch (err) {
      processQueue(err)

      store.commit('authStore/setUser', null)
      store.commit('authStore/setCompany', null)
      store.commit('app/initialized', false)
      failedQueue = []
      isRefreshing = false

      if (router.currentRoute.name !== 'Login') {
        await router.replace({ name: 'Login' })
      }

      return Promise.reject(err)
    } finally {
      isRefreshing = false
    }
  },
)

// Configure the default instance used by the stores. Assigning `axios.timeout`
// does not affect request configuration in Axios.
axios.defaults.timeout = 10000
